import React, { useState } from 'react';

interface CssAnimateProps {
    children: any;
    animationIn?: "slideUp" | "slideDown" | "slideLeft" | "slideRight" | "slideExpandUp" | "expandUp" | "fadeIn" | "fadeOut" | "expandOpen" |
    "bigEntrance" | "hatch" | "bounce" | "pulse" | "floating" | "tossing" | "pullUp" | "pullDown" | "stretchLeft" | "stretchRight" | string | Array<string>;
    animationOut?: "slideUp" | "slideDown" | "slideLeft" | "slideRight" | "slideExpandUp" | "expandUp" | "fadeIn" | "fadeOut" | "expandOpen" |
    "bigEntrance" | "hatch" | "bounce" | "pulse" | "floating" | "tossing" | "pullUp" | "pullDown" | "stretchLeft" | "stretchRight" | string | Array<string>;
    className?: string;
    style?: any;
    time: number;
    willUnmount?: boolean;
}

const CssAnimate: React.FC<CssAnimateProps> = (props: CssAnimateProps) => {
    const { children, animationIn, animationOut, className, style, time, willUnmount } = props;
    let seconds = `${time / 1000}s`;
    const [animationState, setAnimationState] = useState("mounting");
    //r-18-lint-dj
    //eslint-disable-next-line
    const [shouldRender, setShouldRender] = useState(true);

    React.useEffect(() => {
        willUnmount && setAnimationState("unmounting");
    }, [willUnmount])

    const onAnimationEnd = () => {
        if (animationState === "mounting") {
            setAnimationState("waiting");
        }
    };

    return (
        shouldRender
            ? (
                <div
                    className={className}
                    style={{ ...style, animation: `${animationState === "mounting" ? animationIn : animationState === "unmounting" ? animationOut : ""} ${seconds}` }}
                    onAnimationEnd={onAnimationEnd}
                >
                    {children}
                </div>
            )
            : null
    );
}

CssAnimate.defaultProps = {
    animationIn: "fade-in",
    animationOut: "fade-out",
    className: "",
    time: 0.5,
    willUnmount: false
}

export default CssAnimate;